/**
 * Format a number with SI prefixes (k, M, G).
 */
export function formatNumber(n: number, decimals = 1): string {
  const opts = { maximumFractionDigits: decimals };

  if (n < 1_000) return n.toString();
  if (n < 1_000_000) return `${(n / 1_000).toLocaleString("en", opts)}k`;
  if (n < 1_000_000_000)
    return `${(n / 1_000_000).toLocaleString("en", opts)}M`;
  return `${(n / 1_000_000_000).toLocaleString("en", opts)}G`;
}

/**
 * Format a small number for display.
 *
 * Values >= 0.01 are shown with two decimal places. Smaller values use
 * scientific notation (e.g., `2.5e-10`).
 */
export function formatScientific(value: number): string {
  if (value >= 0.01) return value.toFixed(2);
  return value.toExponential(1);
}

/**
 * Format bytes to human-readable string (KB, MB, GB).
 */
export function formatBytes(bytes: number, decimals = 1): string {
  const opts = { maximumFractionDigits: decimals };

  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 ** 2)
    return `${(bytes / 1024).toLocaleString("en", opts)} KB`;
  if (bytes < 1024 ** 3)
    return `${(bytes / 1024 ** 2).toLocaleString("en", opts)} MB`;
  return `${(bytes / 1024 ** 3).toLocaleString("en", opts)} GB`;
}
